<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Parceiros
              <TotalRegisters :total="partnersTableData.total" totalText="ramos" />
            </h4>

            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="visibilityStates.create = true">
                Adicionar Parceiro
              </button>
            </div>
          </div>

          <Table :tableData="partnersTableData" :data="partners" :columns="['id', 'name', 'createdAt', 'toDonate', 'actions']" :actions="['edit', 'view']" @pagechanged="onPageChange" @openDetailsModal="openDetailsModal" @openEditModal="openEditModal"> </Table>
          <ListLoader v-if="partnersTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!partnersTableData.loading && partnersTableData.error"></Error>
          <Empty v-if="!partnersTableData.loading && !partnersTableData.error && partners.length === 0"></Empty>
        </card>
      </div>
    </div>

    <Modal v-model="visibilityStates.create" action="Salvar" title="Adicionar novo parceiro" @closeModal="visibilityStates.create = false" @confirmAction="createPartner(newPartner)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="newPartner.name" placeholder="Ex: UNICEF" />
        </div>

        <div class="form-group">
          <label>Descrição</label>
          <input type="text" class="form-control" v-model="newPartner.description" placeholder="Ex: UNICEF" />
        </div>

        <div class="form-group">
          <label>Detalhes do parceiro (HTML)</label>
          <textarea class="form-control" v-model="newPartner.details" placeholder="<h2>A UNICEF</h2><br><p>Olá tudo bem?</p>"></textarea>
        </div>

        <div class="form-group">
          <label>Logo <span style="font-size:12px;color:rgba(255,255,255,0.8);">(Tamanho recomendado: 128x128)</span></label>
          <button type="button" class="d-block btn btn-primary" @click="$refs.file.click()">
            Upload da Logo
          </button>
          <input style="visibility:hidden;" type="file" id="file" ref="file" v-on:change="handleFileUpload('add')" />
        </div>

        <div class="form-group">
          <label>Imagens <span style="font-size:12px;color:rgba(255,255,255,0.8);">(Tamanho recomendado: 128x128)</span></label>
          <button type="button" class="d-block btn btn-primary" @click="$refs.multipleFiles.click()">
            Escolher arquivos
          </button>
          <input style="visibility:hidden;" type="file" id="multipleFiles" ref="multipleFiles" multiple v-on:change="handleMultipleFileUpload('add')" />
        </div>
      </template>
    </Modal>

    <Modal v-model="visibilityStates.edit" action="Salvar" title="Editar Parceiro" @closeModal="visibilityStates.edit = false" @confirmAction="updatePartner(partner)">
      <template v-slot:body>
        <div class="wrapper-modal" style="max-height: 80vh;overflow:auto;">
          <div class="form-group">
            <label>Nome</label>
            <input type="text" hidden class="form-control" v-model="partner.id" />
            <input type="text" class="form-control" v-model="partner.name" />
          </div>

          <div class="form-group">
            <label>Descrição</label>
            <input type="text" class="form-control" v-model="partner.description" />
          </div>

          <div class="form-group">
            <label>Detalhes do parceiro (HTML)</label>
            <textarea class="form-control" v-model="partner.details"></textarea>
          </div>

          <div class="form-group">
            <label>Logo <span style="font-size:12px;color:rgba(255,255,255,0.8);">(Tamanho recomendado: 128x128)</span></label>
            <img v-if="partner.logo" class="mb-3" style="display:block;max-width:100px;" :src="partner.logo_url" />
            <div style="font-size:10px;" v-else>Nenhuma imagem cadastrada</div>
            <button type="button" class="d-block btn btn-primary" @click="$refs.file.click()">
              Upload da Logo
            </button>
            <input style="visibility:hidden;" type="file" id="file" ref="file" v-on:change="handleFileUpload('add')" />
          </div>

          <div class="form-group">
            <label>Imagens <span style="font-size:12px;color:rgba(255,255,255,0.8);">(Tamanho recomendado: 128x128)</span></label>
            <div class="d-flex" style="flex-wrap:wrap;" v-if="partner.images.length > 0">
              <div v-for="img in partner.images" :key="img.id" class="mr-3 mb-3" :style="{ 'background-image': 'url(' + img.location + ')' }" style="width:100px;height:66px;background-size:cover;"></div>
            </div>
            <div style="font-size:10px;" v-else>Nenhuma imagem cadastrada</div>
            <button type="button" class="d-block btn btn-primary" @click="$refs.multipleFiles.click()">
              Escolher arquivos
            </button>
            <input style="visibility:hidden;" type="file" id="multipleFiles" ref="multipleFiles" multiple v-on:change="handleMultipleFileUpload('add')" />
          </div>
        </div>
      </template>
    </Modal>

    <Modal v-model="visibilityStates.read" action="Ok" title="Informações das doações" @closeModal="visibilityStates.read = false" @confirmAction="(visibilityStates.read = false), (donatedValue = null), (startDate = null), (endDate = null)">
      <template v-slot:body>
        <div>
          <label style="text-decoration:underline;">Visualizar doação por periodo</label>
          <div class="form-group">
            <label>Data de Inicio</label>
            <input type="date" v-model="startDate" class="form-control" />
          </div>
          <div class="form-group">
            <label>Data de Término</label>
            <input type="date" v-model="endDate" class="form-control" />
          </div>
          <div class="form-group">
            <button class="btn btn-info w-100" :disabled="startDate === null || endDate === null" @click="calculateDonatedValue(startDate, endDate)">Verificar</button>
          </div>
          <div v-if="donatedValue !== null" class="form-group">
            <label>Valor já doado no período selecionado:</label>
            <p>R$ {{ donatedValue }}</p>
          </div>
        </div>
        <hr style="background-color:#fff;" />
        <div>
          <label style="text-decoration:underline;">Efetuar pagamento de doação</label>
          <div class="form-group">
            <label
              >Saldo disponível: R$
              {{ partner.to_donate }}
            </label>
          </div>
          <div class="form-group">
            <button :disabled="partner.to_donate === 0" class="btn btn-info w-100" @click="doDonation()">Realizar pagamento</button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import api from '@/api.js';
import Table from '@/components/Common/Table';
import Search from '@/components/Common/Search';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Modal from '@/components/Modal/Modal';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Modal,
    TotalRegisters,
    Treeselect,
    Search,
    Table,
  },
  data() {
    return {
      donatedValue: null,
      startDate: null,
      endDate: null,
      multipleFiles: [],
      temporaryImage: null,
      temporaryMultipleImages: null,
      newPartner: {
        name: '',
      },
      successMessage: '',
      visibilityStates: {
        create: false,
        edit: false,
        delete: false,
        read: false,
      },
    };
  },
  computed: {
    partners() {
      return this.$store.getters['partners/getPartners'];
    },
    partnersTableData() {
      return this.$store.getters['partners/getPartnersTableData'];
    },
    partner() {
      return this.$store.getters['partners/getPartner'];
    },
  },
  methods: {
    doDonation: async function() {
      await api.patch(`donations/confirm/${this.partner.id}`);
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: 'Pagamento realizado com sucesso',
      });

      await this.$store.dispatch('partners/getPartnerById', this.partner.id);
      this.$store.dispatch('partners/resetPagination');
    },
    calculateDonatedValue: async function(startDate, endDate) {
      let params = {
        partnerId: this.partner.id,
        dateIni: new Date(startDate),
        dateEnd: new Date(endDate),
      };
      const res = await api.get(`donations/donated`, { params });
      this.donatedValue = res.data.donated;
    },
    handleMultipleFileUpload: async function(type) {
      for (var i = 0; i < this.$refs.multipleFiles.files.length; i++) {
        let file = this.$refs.multipleFiles.files[i];
        this.multipleFiles.push(file);
      }
      this.submitMultipleFiles(type);
    },
    submitMultipleFiles: async function(type) {
      let formData = new FormData();

      for (var i = 0; i < this.multipleFiles.length; i++) {
        let file = this.multipleFiles[i];
        formData.append('image', file);
      }

      if (type === 'add') {
        this.temporaryMultipleImages = formData;
      }
    },
    handleFileUpload: async function(type) {
      this.file = this.$refs.file.files[0];
      this.submitFile(type);
    },
    submitFile: async function(type) {
      let formData = new FormData();
      formData.append('image', this.file);

      if (type === 'add') {
        this.temporaryImage = formData;
      }
    },
    createPartner: async function(payload) {
      const partnerId = await this.$store.dispatch('partners/create', payload);

      if (this.temporaryImage) {
        await api.patch(`partners/logo/${partnerId}`, this.temporaryImage, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      if (this.temporaryMultipleImages) {
        await api.post(`partners/images/${partnerId}`, this.temporaryMultipleImages, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      this.temporaryImage = null;
      this.temporaryMultipleImages = null;
      this.multipleFiles = [];
      this.visibilityStates.create = false;
      this.newPartner = {};
    },
    updatePartner: async function(params) {
      let payload = {
        id: params.id,
        params: {
          name: params.name,
          description: params.description,
          details: params.details,
        },
      };
      await this.$store.dispatch('partners/updatePartner', payload);

      if (this.temporaryImage) {
        await api.patch(`partners/logo/${params.id}`, this.temporaryImage, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      if (this.temporaryMultipleImages) {
        await api.post(`partners/images/${params.id}`, this.temporaryMultipleImages, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      this.temporaryImage = null;
      this.temporaryMultipleImages = null;
      this.multipleFiles = [];
      this.visibilityStates.edit = false;
    },
    openDetailsModal: async function(id) {
      await this.$store.dispatch('partners/getPartnerById', id);
      this.visibilityStates.read = true;
    },
    openEditModal: async function(id) {
      await this.$store.dispatch('partners/getPartnerById', id);
      this.visibilityStates.edit = true;
    },
    onPageChange(page) {
      this.$store.dispatch('partners/setPage', page);
    },
  },
  mounted() {
    this.$store.dispatch('partners/resetPagination');
  },
};
</script>
<style scoped>
::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
</style>
